import { orderService } from '../../../services/Order/orderService';
import { OrderDto } from '../../../services/Order/orderService.dto';
import { UserDetailsDto } from '../../../services/User/userService.dto';

const webAppUrl: string = process.env.REACT_APP_WEB_APP_ROOT_URL || '';

export const generateCheckoutLink = async (
  order: OrderDto,
  technicalUser: UserDetailsDto,
  refetchTechnicalUser: () => Promise<UserDetailsDto>,
  refresh: boolean
) => {
  const reassignmentToken = await fetchReassignmentToken(order, refresh);
  const resolvedTechnicalUser = await resolveTechnicalUser(technicalUser, refetchTechnicalUser, refresh);

  const checkoutData = {
    orderId: order.id,
    username: resolvedTechnicalUser.draftEmail || resolvedTechnicalUser.email,
    password: resolvedTechnicalUser.technicalAccountPassword,
    reassignmentToken,
  };

  const encodedData = encodeData(checkoutData);

  return `${webAppUrl}/onsite-checkout/${encodedData}`;
};

const fetchReassignmentToken = async (order: OrderDto, refresh: boolean) => {
  const orderResponse = await orderService.enableOrderMutation(order.id, refresh);
  return orderResponse.data.reassignmentToken;
};

const resolveTechnicalUser = async (
  technicalUser: UserDetailsDto,
  refetchTechnicalUser: () => Promise<UserDetailsDto>,
  refresh: boolean
) => {
  if (refresh) {
    return await refetchTechnicalUser();
  } else {
    return technicalUser;
  }
};

const encodeData = (data: {}): string => {
  const jsonData = JSON.stringify(data);
  return btoa(jsonData);
};
